import useBrowserMode from "./useBrowserMode";
// import useLocaleMode from "./useLocaleMode";

export default function useHomeLinkMode() {
    const { isBrowser } = useBrowserMode();
    // const { localePath } = useLocaleMode();
    const homeLink = isBrowser ? '//' + window.location.host + '/' : '/';
    return { homeLink }
}